import { type ReactElement } from 'react';
import { TdsIcon } from '@scania/tegel-react';
import { NotAvailable } from '../../../NotAvailable';
import styles from './style.module.scss';
import ProgressBar from '@/common/components/ProgressBar';

interface MetricProgressCardProperties {
  readonly iconName: React.ComponentProps<typeof TdsIcon>['name'];
  readonly title: string;
  readonly progressPercent?: number;
  readonly primaryValue?: string;
  readonly minLabel: string;
  readonly maxLabel?: string;
  readonly hideIncompleteFooter?: boolean;
  readonly unavailable?: boolean;
}

const MetricProgressCard = ({
  iconName,
  title,
  progressPercent,
  primaryValue,
  minLabel,
  maxLabel,
  hideIncompleteFooter = false,
  unavailable = false,
}: MetricProgressCardProperties): ReactElement => {
  const showFooter =
    !unavailable &&
    (!hideIncompleteFooter || (primaryValue !== undefined && progressPercent !== undefined && maxLabel !== undefined));

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <TdsIcon name={iconName} size="24px" />
        <h3 className={styles.title}>{title}</h3>
        <span className={styles['primary-value']}>
          {unavailable ? <NotAvailable label="Not available" /> : (primaryValue ?? <NotAvailable />)}
        </span>
      </div>
      {showFooter && (
        <div className={styles.footer}>
          <div className={styles['progress-row']}>
            {progressPercent === undefined ? <NotAvailable /> : <ProgressBar progressPercent={progressPercent} />}
          </div>
          <div className={styles['labels-row']}>
            <span className={styles['min-label']}>{minLabel}</span>
            <span className={styles['max-label']}>{maxLabel ?? <NotAvailable />}</span>
          </div>
        </div>
      )}
    </section>
  );
};

export default MetricProgressCard;
